import { Link } from "react-router-dom";

import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";
import { useNavigate } from 'react-router-dom';
import getPrivilegeList from "../../PrivilegeList";
import React, { } from "react";
import HelpSupportButton from "../HelpSupportButton"; // path check karo apna


const AdminNavbar = (props) => {
  const navigate = useNavigate();
const privilegeList = getPrivilegeList();

  const handleLogout = async (e) => {
  // Remove the auth cookie
  document.cookie = "auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  // Optional: remove anything else like tokens from storage
  localStorage.removeItem("auth_data"); // if stored
  sessionStorage.setItem("logout", "true"); // set flag for login redirect check
navigate('/auth/login'); 
localStorage.clear(); 

};


  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Nav className="align-items-center d-none d-md-flex ml-auto" navbar>


         <UncontrolledDropdown nav>
  <DropdownToggle className="pr-0" nav>
    <Media className="align-items-center">
      <span className="avatar avatar-sm rounded-circle">
        <img
          alt="..."
          src={require("../../assets/img/default_user.jpg")}
        />
      </span>
      <Media className="ml-2 d-none d-lg-block">
        <span className="mb-0 text-sm font-weight-bold">
        {localStorage.getItem("user_name") || "User Name"}
        </span>
      </Media>
    </Media>
  </DropdownToggle>
  <DropdownMenu className="dropdown-menu-arrow" right>
    <DropdownItem className="noti-title" header tag="div">
      <h6 className="text-overflow m-0">Welcome!</h6>
    </DropdownItem>

    <DropdownItem href="/admin/lead-list">
      <i className="ni ni-bullet-list-67" />
      <span>Lead List</span>
    </DropdownItem>
    {privilegeList.loanAgreementShow && (
    <DropdownItem href="/Agreement/LoanAgreement">
      <i className="ni ni-single-copy-04" />
      <span>Loan Agreement</span>
    </DropdownItem>
    )}
    
    {privilegeList.lspListTabShow && (
    <DropdownItem href="/admin/lsp-list">
      <i className="ni ni-building" />
      <span>LSP List</span>
    </DropdownItem>
    )}
    
    {privilegeList.privilegeTabShow && (
    <DropdownItem href="/admin/privilege">
      <i className="ni ni-key-25" />
      <span>Privilege</span>
    </DropdownItem>
     )} 

    {privilegeList.createNewUserShow && (
    <DropdownItem href="/admin/admin-panel">
      <i className="ni ni-single-02" />
      <span>Create New User</span>
    </DropdownItem>
    )}

    {privilegeList.breTabShow && (
      <DropdownItem href="/admin/bre-panel">
        <i className="fa-solid fa-virus-covid" />
        <span>BRE</span>
      </DropdownItem>
    )}

    {privilegeList.payOutRequestTabShow && (
      <DropdownItem href="/admin/payout-request">
        <i class="fa-brands fa-cc-amazon-pay"></i>
        <span>Pay Out Request</span>
      </DropdownItem>
    )}

    {privilegeList.blockAreaShow && (
  <DropdownItem href="/admin/block-area">
    <i className="ni ni-square-pin" />
    <span>Block Area</span>
  </DropdownItem>
    )}

 
     {privilegeList.templateShow && (
<DropdownItem href="/admin/template">
  <i className="ni ni-collection" />
  <span>Template</span>
</DropdownItem>
 )}

 {privilegeList.reportingShow && (
 <DropdownItem href="/admin/reporting">
    <i className="ni ni-chart-bar-32" />
    <span>Reporting</span>
  </DropdownItem>
 )}
  


 {privilegeList.fintechWalletShow && (
 <DropdownItem href="/admin/fintech-Wallet">
                  <i className="fa-solid fa-building-columns" />
                  <span>Fintech Wallet</span>
                </DropdownItem>
 )}

                
{privilegeList.lspBalanceShow && (
<DropdownItem href="/admin/lsp-balance">
  <i className="ni ni-money-coins" />
  <span>LSP Balance</span>
</DropdownItem>
)}

 
    <DropdownItem divider />
    <DropdownItem href="" onClick={handleLogout}>
      <i className="ni ni-user-run" />
      <span>Logout</span>
    </DropdownItem>
  </DropdownMenu>
</UncontrolledDropdown>

          </Nav>
        </Container>
      </Navbar>
          <HelpSupportButton />

    </>
  );
};

export default AdminNavbar;
    